module.exports = __webpack_public_path__ + "static/media/Picture64.f158a7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture64.png
// module id = 1534
// module chunks = 0